import type { Migration } from './types';

export function createMigration({
    migrateVideo,
    migrateTemplate = (template) => template,
    migrateScene = (scene) => scene,
}: Migration): Migration {
    return {
        migrateVideo,
        migrateTemplate,
        migrateScene,
    };
}
